import axios from "axios";
import React, { useState, useEffect } from "react";

const Privacypolicy = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND + "privacy-policy/get-policy")
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <div className="container " style={{ background: "var(--white-color)" }}>
      <h1 className="pt-4 t-center py-4">Privacy and Policies</h1>
      <div
        dangerouslySetInnerHTML={{ __html: data[0]?.content }}
        className="p-4 ql-editor"
      />
    </div>
  );
};

export default Privacypolicy;
